import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeSlug from "rehype-slug";
import rehypeAutolinkHeadings from "rehype-autolink-headings";
import rehypeRaw from "rehype-raw";
import { useGetHelpMarkdown } from "../components/help/useGetHelpMarkdown";
import "../components/help/help.css";
import { renderers } from "../components/help/renderers";

interface HelpProps {
  isLoggedIn: boolean;
  language?: string;
}

export interface Content {
  content: string;
  language: string;
}

const Help: React.FC<HelpProps> = ({ isLoggedIn, language }) => {
  const [content, setContent] = useState<Content>({
    content: "",
    language: "en",
  });
  const {
    mutate: getHelpMarkdown,
    isLoading,
    isError,
  } = useGetHelpMarkdown({
    onSuccess: (data) => {
      setContent(data);
    },
    onError: (error) => {
      console.error("Error fetching help content", error);
    },
  });

  useEffect(() => {
    getHelpMarkdown({ language: mapLanguage(language) });
  }, [language, getHelpMarkdown]);

  useEffect(() => {
    if (isLoggedIn) {
      getHelpMarkdown({ language: mapLanguage(language) });
    }
  }, [isLoggedIn, language, getHelpMarkdown]);

  const mapLanguage = (lang?: string): string => {
    return lang?.split("-")[0] || "en";
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error loading help content.</div>;
  }

  if (content.content) {
    return (
      <div>
        <ReactMarkdown rehypePlugins={[rehypeSlug, rehypeAutolinkHeadings, rehypeRaw as any]} components={renderers}>
          {content.content}
        </ReactMarkdown>
      </div>
    );
  }

  return <div>No help content available.</div>;
};

export default Help;
